export const clock = () => (
  <path
    strokeLinecap="round"
    strokeLinejoin="round"
    d="M12 6v6l4 2m6-2c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10z"
  />
);
